<template>
  <div class="capital">
    <div class="title">账户余额（元）</div>
    <div class="handle">
      <div class="num">{{balance}}</div>
      <div class="btn-view">
        <Button type="primary" class="recharge" @click="$router.push({name:'recharge'})">充值</Button>
        <Button type="warn" @click="$router.push({name:'withdrawal'})">提现</Button>
				<Button type="text" @click="$router.push({name:'wallet_index'})">消费明细</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'capital',
  data () {
    return {
      balance: 0,
      head_img: '',
      nickname: ''
    }
  },
  created () {
    let vm = this
    this.$store.dispatch('getUserInfo').then(res => {
      vm.balance = res.balance
      vm.head_img = res.head_img
      vm.nickname = res.nickname
      vm.check = res.check
    })
  }
}
</script>

<style scoped lang="less">
.capital {
  width: 600px;
  height: 130px;
  border:2px solid #f7f8fa;
  border-radius: 3px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title{
    font-size: 18px;
    color: #333;
    font-weight: 700;
  }
  .handle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .num{
      font-size: 24px;
      color: #333;
    }
    .btn-view{
      .recharge{
        margin-right: 10px;
      }
    }
  }
}
</style>
